import { Box as RadixBox, type BoxProps as RadixBoxProps } from '@radix-ui/themes';
import { cn } from '@/lib/utils';
import { type RadixColors } from './RadixProps';

type BoxProps = RadixBoxProps & {
  border?: boolean;
  borderColor?: RadixColors;
};

export function Box({ className, border, borderColor, style, ...props }: BoxProps) {
  const hasBorder = border || borderColor;

  return (
    <RadixBox
      className={cn(hasBorder && 'border', className)}
      data-accent-color={borderColor}
      style={{
        ...(hasBorder && { borderColor: 'var(--accent-9)' }),
        ...style,
      }}
      {...props}
    />
  );
}

export type { BoxProps };
